/** @jsx jsx */
import { jsx } from '@emotion/react';
import { forwardRef } from 'react';
import type { FC, HTMLProps } from 'react';

const VisuallyHidden: FC = forwardRef<HTMLSpanElement, HTMLProps<HTMLSpanElement>>(
  ({ children, ...spanProps }, ref) => (
    <span
      css={{
        border: 'none',
        clip: 'rect(0 0 0 0)',
        height: 1,
        width: 1,
        margin: -1,
        padding: 0,
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        wordWrap: 'normal',
      }}
      {...spanProps}
      ref={ref}
    >
      {children}
    </span>
  ),
);

VisuallyHidden.displayName = 'VisuallyHidden';

export default VisuallyHidden;
